import $http from '../http'
import { baseUrl } from '../url'
const BASEURL = baseUrl.primary + '/v1'

const base = {
  getEnumerationData(className) {
    return $http({
      method: 'get',
      url: `${BASEURL}/Enumeration/GetEnumByClassName?className=${className}`
    })
  },
  getCitys() {
    return $http({
      method: 'get',
      url: `${BASEURL}/Main/CityManage/GetCityList?_${new Date().getTime()}`
    })
  },
  addCitys(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/Main/Admin/CityManage/AddCity`,
      data
    })
  },
  editCitys(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/Main/Admin/CityManage/EditCity`,
      data
    })
  },
  removeCity(id) {
    return $http({
      method: 'post',
      url: `${BASEURL}/Main/Admin/CityManage/DeleteCity?id=${id}`
    })
  },
  attendance(isOnDuty) {
    return $http({
      method: 'post',
      url: `${BASEURL}/Main/Attendance/EditAttendance?isOnDuty=${isOnDuty}`
    })
  },
  getTodayAttendance() {
    return $http({
      method: 'get',
      url: `${BASEURL}/Main/Attendance/GetTodayAttendance`
    })
  },
  getHistoryAttendance(params) {
    return $http({
      method: 'get',
      url: `${BASEURL}/Main/Attendance/AttendancePage`,
      params
    })
  }
  // ,
  // getHistoryAttendanceExport(params) {
  //   return $http({
  //     method: 'get',
  //     url: `${BASEURL}/Main/Attendance/Export`,
  //     params
  //   })
  // }
}

export default base
